import { useRef, useId } from 'react'
import { useCallback } from 'react'
import { useEffect } from 'react'
import { REM } from '../../../constants/fontsize'
import { useMenu } from 'react-instantsearch'
import type { Swiper } from 'swiper/types'
import type { SwiperContainer } from 'swiper/element/bundle'
import sliderStyles from './slider-styles.raw.css'

function GroupFilter(props: {
  labels?: Record<string, string>
  attribute: string
  icons: Record<string, string>
  ariaLabel: string
}) {
  const { refine: refineMenu, items: menuItems } = useMenu({
    attribute: props.attribute
    // sortBy: ['count:desc', 'name:asc']
  })

  const onSelect = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value
    refineMenu(value)
  }

  if (menuItems.length === 0) {
    return null
  }

  return (
    <GroupFilterSlider
      labels={props.labels}
      items={menuItems}
      icons={props.icons}
      ariaLabel={props.ariaLabel}
      onSelect={onSelect}
    />
  )
}

export function GroupFilterSlider(props: {
  labels?: Record<string, string>
  items: { value: string; label?: string; isRefined: boolean }[]
  icons: Record<string, string>
  ariaLabel: string
  onSelect: (evt: React.ChangeEvent<HTMLInputElement>) => void
}) {
  const swiperRef = useRef<SwiperContainer | null>(null)

  const onProgress = useCallback((swiper: Swiper) => {
    const previousGradient =
      swiperRef.current?.querySelector('.previous-gradient')
    previousGradient?.classList.toggle('hidden', swiper.progress === 0)

    const nextGradient = swiperRef.current?.querySelector('.next-gradient')
    nextGradient?.classList.toggle('hidden', swiper.progress === 1)
  }, [])

  useEffect(() => {
    if (swiperRef.current) {
      Object.assign(swiperRef.current, {
        injectStyles: [sliderStyles],
        freeMode: true,
        navigation: true,
        slidesPerView: 'auto',
        spaceBetween: REM * 0.5,
        direction: 'horizontal',
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        on: {
          progress: onProgress
        },
        breakpoints: {
          768: {
            spaceBetween: 1.8 * REM
          }
        }
      })
      swiperRef.current.initialize()
    }
  }, [onProgress])

  const getIcon = (value: string) => props.icons[value] ?? ''

  const id = useId()

  return (
    <fieldset className="d-flex flex-grow-1 me-3">
      <legend className="visually-hidden">{props.ariaLabel}</legend>
      <swiper-container
        ref={swiperRef}
        init="false"
        /* @ts-ignore */
        class="category-filter-slider w-100"
      >
        <div
          slot="container-start"
          className="navigation-gradient previous-gradient"
        />
        {props.items.map((item) => (
          <swiper-slide key={item.value}>
            <input
              type="checkbox"
              id={`${id}-${item.value}`}
              className="btn-check"
              checked={item.isRefined}
              value={item.value}
              onChange={props.onSelect}
            />
            <label
              htmlFor={`${id}-${item.value}`}
              className="btn category-filter-button"
            >
              <i
                className={`icon ${getIcon(item.value) || 'd-none'}`}
                aria-hidden="true"
              />
              <p>{props.labels?.[item.value] ?? item.value}</p>
            </label>
          </swiper-slide>
        ))}
        <div
          slot="container-end"
          className="navigation-gradient next-gradient"
        />
      </swiper-container>
    </fieldset>
  )
}

export default GroupFilter
